/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Api_Errors_Week_OngeldigInputs */

const nl_planning_api_errors_week_ongeldig = /** @type {(inputs: Planning_Api_Errors_Week_OngeldigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze week valt buiten het schooljaar.`)
};

/**

* @param {Planning_Api_Errors_Week_OngeldigInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_api_errors_week_ongeldig = /** @type {((inputs?: Planning_Api_Errors_Week_OngeldigInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Api_Errors_Week_OngeldigInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_api_errors_week_ongeldig(inputs)
});
export { planning_api_errors_week_ongeldig as "planning.api_errors.week_ongeldig" }